import request from './request'
import serializeParams from '../utils/serialize' // 序列化参数
import {
    merchantId
} from './request'
// 获取导览详情
export function getIndoorGuide(id) {
    return request({
        url: `/saasapi/indoor-voice-explanatio/${id}`,
        method: 'GET',
    })
}
//  获取分类列表
export function getVoiceCategory(data) {
    return request({
        url: `/saasapi/indoor-voice-category`,
        method: 'get',
        params: data
    })
}

//  获取所在楼层 所在分类下的景点
export function getVoiceSpots(data) {
    return request({
        url: `/saasapi/indoor-voice-spots`,
        method: 'get',
        params: data
    })
}
// 获取路线
export function getIndoorVoiceRoute(data) {
    return request({
        url: `/saasapi/indoor-voice-route`,
        method: 'get',
        params: data
    })
}

















/**
 * @description 定义自定义“分享给朋友或朋友圈”及“分享到QQ或QQ空间”的展示信息。
 * @param {Object} res 活动信息对象，解构出来变量的id、name、rule、img、merchant_id
 * @param {Object} that 组件实例this
 */
export const defineCustomSharing = async({
    data: {
        items
    }
}, that) => {

    console.log('defineCustomSharing进来了');
    // 1. 首先获取JS-SDK配置数据
    const res = await request({
        url: '/saasapi/wechat-config',
        method: 'get',
        params: {
            operate: 'getJsapiConfig',
            url: window.location.href
        }
    })
    console.log('defineCustomSharing进来了，res=>', res);

    // 2. 判断JS-SDK配置数据是否获取成功， 成功再执行如下代码
    if (res.success) {
        console.log('res.data.success', res)

        // 初始化一些数据
        const HOST = 'https://www.xiaoniren.cn'
        const url = window.location.href
        const params = {
            url,
            appid: res.data.appId
        }
        const voicePictureObj = items[0]
        const options = {
            title: voicePictureObj.name, // 分享标题
            desc: voicePictureObj.name, // 页面描述、摘要
            link: `${HOST}/mp/activity-transform.html?${encodeURIComponent(
        serializeParams(params)
      )}`,
            imgUrl: HOST + voicePictureObj.img,
            success: () => {
                console.log('分享成功')
            }
        }

        // 3. 注入配置信息
        that.$wx.config({
            ...res.data,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ]
        })

        // 4. 处理成功验证
        console.log('进来了')
        that.$wx.ready(() => {
            that.$wx.updateTimelineShareData && that.$wx.updateTimelineShareData(options)
            that.$wx.updateAppMessageShareData && that.$wx.updateAppMessageShareData(options)
            that.$wx.onMenuShareTimeline && that.$wx.onMenuShareTimeline(options)
            that.$wx.onMenuShareAppMessage && that.$wx.onMenuShareAppMessage(options)
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/api.js